module.exports = __webpack_public_path__ + "images/fc231809.www_10_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/www_10_cht.png
// module id = 539
// module chunks = 0